export class IndexUtils {
    static instance: IndexUtils
    utils: any = null

    constructor(utils: any) {
        if (IndexUtils.instance) {
            return IndexUtils.instance
        }

        this.utils = utils

        IndexUtils.instance = this
        return this
    }

    isNotBgb(modell: any) {
        return modell !== 1
    }
}
